import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import axios from "../../../config/axios";
import "./modal.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Modals = ({
  setLgShow,
  lgShow,
  userId,
  notifications,
  setNotifications,
}) => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await axios.get(
          `/notification/mine?userId=${userId}&limit=20&skip=0`,
        );
        if (res.data.success) setNotifications(res.data.data);
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };
    fetchNotifications();
  }, [userId, setNotifications]);

  // Delete single notification
  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(`/notification/${id}?userId=${userId}`);
      if (res.data.success) {
        setNotifications((prev) => prev.filter((n) => n._id !== id));
      }
    } catch (err) {
      console.error("Error deleting notification:", err);
    }
  };

  // Clear all notifications
  const handleClearAll = async () => {
    try {
      const res = await axios.delete(`/notification/user/${userId}`);
      if (res.data.success) {
        setNotifications([]);
      }
    } catch (err) {
      console.error("Error clearing notifications:", err);
    }
  };

  const openShopInvitation = (notification) => {
    if (
      notification.type !== "SHOP_ACCESS_INVITATION" ||
      !notification.meta?.membershipId
    ) {
      return;
    }
    setLgShow(false);
    navigate(
      notification.meta.invitationPath ||
        `/shop-access-invitation/${notification.meta.membershipId}`,
    );
  };

  return (
    <Modal
      show={lgShow}
      onHide={() => setLgShow(false)}
      aria-labelledby="notifications-modal"
      centered
      size="lg"
    >
      <Modal.Header className="border-bottom-0">
        <Modal.Title id="notifications-modal">Notifications</Modal.Title>
        {notifications.length > 0 && (
          <Button
            variant="outline-danger"
            size="sm"
            onClick={handleClearAll}
            className="ms-2"
          >
            Clear All
          </Button>
        )}
        <Button variant="close" onClick={() => setLgShow(false)} />
      </Modal.Header>

      <Modal.Body className="header-notification premium-scroll p-3">
        {notifications.length === 0 && (
          <div className="text-center py-5 text-muted">
            <p>No notifications yet.</p>
          </div>
        )}

        {notifications.map((n) => (
          <Row
            key={n._id}
            className="align-items-center notification-item mb-3 p-2 rounded hover-shadow"
          >
            <Col
              role={n.type === "SHOP_ACCESS_INVITATION" ? "link" : undefined}
              tabIndex={n.type === "SHOP_ACCESS_INVITATION" ? 0 : undefined}
              onClick={() => openShopInvitation(n)}
              onKeyDown={(event) => {
                if (
                  n.type === "SHOP_ACCESS_INVITATION" &&
                  (event.key === "Enter" || event.key === " ")
                ) {
                  event.preventDefault();
                  openShopInvitation(n);
                }
              }}
            >
              <h6 className="notification-title mb-1">{n.title}</h6>
              <p className="notification-message mb-0">{n.message}</p>
            </Col>

            <Col xs="auto" className="text-end">
              <small className="text-muted d-block mb-2">
                {new Date(n.createdAt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </small>

              {n.type === "CONNECTION_REQUEST" && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    setLgShow(false);
                    navigate(`/connection-request/${name._id}`);
                  }}
                  className="me-2"
                >
                  View
                </Button>
              )}

              {n.type === "SHOP_ACCESS_INVITATION" &&
                n.meta?.membershipId && (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => {
                      openShopInvitation(n);
                    }}
                    className="me-2"
                  >
                    Review access
                  </Button>
                )}

              <Button
                variant="outline-danger"
                size="sm"
                onClick={(event) => {
                  event.stopPropagation();
                  handleDelete(n._id);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default Modals;
